import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IEnrichedMenuWithModifierMaps } from 'components/menu/model/Menu';
import { IOrderReadResourceV18, OrderScenario } from 'components/order/model/Order';
import { orderApi } from 'components/order/orderApi';
import { validateRecentOrder } from 'components/recentOrders/utils';
import logger from 'lib/logger';

export interface OrdersState {
    error: string;
    isLoading: boolean;
    recentOrders?: IOrderReadResourceV18[];
}

export const initialState: OrdersState = {
    error: '',
    isLoading: true,
    recentOrders: undefined
};

export interface IOrdersOptions {
    scenario?: OrderScenario;
    locationId?: string;
    limit?: number;
    isOpen?: boolean;
    startKey?: string;
}

export const getRecentOrders = createAsyncThunk(
    'orders/getRecentOrders',
    async ({ menu, options }: { menu: IEnrichedMenuWithModifierMaps; options: IOrdersOptions }) => {
        const response = await orderApi.getOrders(options);
        const validOrders = response.items.filter(recentOrder =>
            validateRecentOrder(recentOrder.items, menu)
        );
        return validOrders;
    }
);

const ordersSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getRecentOrders.pending, state => {
                state.isLoading = true;
            })
            .addCase(getRecentOrders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = '';
                state.recentOrders = action.payload;
            })
            .addCase(getRecentOrders.rejected, (state, action) => {
                state.isLoading = false;
                state.recentOrders = undefined;
                state.error = action.error.message ?? '';
                logger.error(action.error);
            });
    }
});

export default ordersSlice.reducer;
